import { appUrl } from '@astro/config'
import { PLANET_STONES } from './gemstoneData'

export default function GemstoneFinderSection() {
  return (
    <section className="relative overflow-hidden hero-vedic py-16 md:py-24 md:px-18 text-white border-y border-white/5">
      <div className="pointer-events-none absolute inset-0 opacity-[0.05] bg-[radial-gradient(#E6C878_1px,transparent_1.5px)] bg-size-[26px_26px]" />
      <div className="pointer-events-none absolute -left-24 top-6 h-80 w-80 rounded-full bg-[radial-gradient(circle,rgba(111,139,255,0.14),transparent_70%)] blur-3xl" />
      <div className="pointer-events-none absolute -right-24 bottom-0 h-80 w-80 rounded-full bg-[radial-gradient(circle,rgba(232,119,15,0.18),transparent_70%)] blur-3xl" />

      <div className="container relative z-10 mx-auto px-6 max-w-350">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div className="space-y-5">
            <div className="flex items-center gap-3">
              <span className="grid h-9 w-9 place-items-center rounded-xl bg-secondary/15 text-secondary ring-1 ring-secondary/30">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4">
                  <path d="M6 3h12l4 6-10 13L2 9Z" />
                  <path d="M11 3 8 9l4 13 4-13-3-6" />
                  <path d="M2 9h20" />
                </svg>
              </span>
              <span className="font-mono text-[10px] font-semibold uppercase tracking-[0.45em] text-secondary">Spiritual Remedy Node</span>
            </div>
            <h2 className="font-cinzel text-3xl leading-tight text-[#FBF3E4] md:text-4xl lg:text-5xl">
              Find the Right Gemstone <span className="text-gradient-gold">for Your Kundli</span>
            </h2>
            <p className="max-w-xl text-sm leading-relaxed text-white/60 normal-case">
              Balance your planetary energy with authentic, lab-certified and energized gemstones — chosen for the exact grahas that need strengthening in your birth chart.
            </p>

            <div className="grid grid-cols-2 gap-2.5">
              {[
                { label: 'Planet-Matched', icon: 'gem' },
                { label: 'Lab-Certified', icon: 'shield' },
                { label: 'Energized by Maharaj Ji', icon: 'flame' },
                { label: 'Wearing Vidhi Guide', icon: 'book' },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-2.5 rounded-xl border border-white/10 bg-white/4 px-3 py-2.5">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4 shrink-0 text-secondary">
                    {item.icon === 'gem' && (
                      <>
                        <path d="M6 3h12l4 6-10 13L2 9Z" />
                        <path d="M11 3 8 9l4 13 4-13-3-6" />
                        <path d="M2 9h20" />
                      </>
                    )}
                    {item.icon === 'shield' && (
                      <>
                        <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                        <path d="m9 12 2 2 4-4" />
                      </>
                    )}
                    {item.icon === 'flame' && <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" />}
                    {item.icon === 'book' && (
                      <>
                        <path d="M12 7v14" />
                        <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" />
                      </>
                    )}
                  </svg>
                  <span className="text-[11px] uppercase tracking-wide text-white/70">{item.label}</span>
                </div>
              ))}
            </div>

            <div className="space-y-2">
              <p className="text-[10px] uppercase tracking-[0.3em] text-white/40">Stones for the 9 Planets</p>
              <div className="grid grid-cols-5 gap-2 max-w-md sm:grid-cols-9">
                {PLANET_STONES.map((p) => (
                  <a
                    key={p.title}
                    title={`${p.title} · ${p.stone}`}
                    className="grid h-10 w-full place-items-center rounded-lg border border-white/10 bg-white/4 text-xl leading-none text-[#F4DEA6] transition-all hover:-translate-y-0.5 hover:border-secondary/50 hover:bg-secondary/10 hover:text-secondary"
                    href={appUrl('shop', `/gemstone?s=${p.stone}`)}
                  >
                    {p.glyph}
                  </a>
                ))}
              </div>
            </div>

            <a
              className="inline-flex items-center justify-center whitespace-nowrap focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 active:scale-95 py-2 group h-12 rounded-full bg-secondary px-9 text-[11px] font-semibold uppercase tracking-[0.24em] text-primary shadow-lg shadow-secondary/20 transition-all hover:bg-[#FBF3E4] border-none"
              href={appUrl('shop', '/gemstone')}
            >
              Explore Gemstones
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1">
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
            </a>
          </div>

          <div>
            <div className="relative mx-auto w-full max-w-95 rounded-3xl border border-[#C8922A]/20 bg-white p-6 shadow-xl">
              <div className="flex items-center gap-3">
                <div className="grid h-12 w-12 place-items-center rounded-2xl bg-[#C8922A]/10 text-2xl text-[#C8922A]">♈</div>
                <div>
                  <h3 className="font-cinzel text-lg text-[#1C140A]">Aries · Mesha</h3>
                  <p className="text-[10px] uppercase tracking-[0.3em] text-[#C8922A]">Today&apos;s Reading</p>
                </div>
              </div>
              <div className="mt-6 space-y-3">
                {[
                  { label: 'Love', value: 82 },
                  { label: 'Career', value: 90 },
                  { label: 'Health', value: 68 },
                ].map((stat) => (
                  <div key={stat.label}>
                    <div className="flex justify-between text-[10px] uppercase mb-1 text-[#8B7355]">
                      <span>{stat.label}</span>
                      <span>{stat.value}%</span>
                    </div>
                    <div className="h-1.5 w-full bg-[#FDFAF6] rounded-full">
                      <div className="h-full bg-[#C8922A] rounded-full" style={{ width: `${stat.value}%` }} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
